module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_0.f1864b5f.png";